import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';

export default function Navbar() {
  const { customer, logout } = useCustomerAuth();
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'text-[var(--color-accent)]' : 'text-[var(--color-text)] hover:text-[var(--color-accent)]'}`;

  return (
    <nav className="sticky top-0 z-50 bg-[var(--color-bg)] border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="flex items-center">
            <img src="/logo-inline.svg" alt="Skaha Sauna Co." className="h-10" style={{ filter: 'brightness(0)' }} />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center space-x-1">
            <NavLink to="/" end className={linkClass}>Home</NavLink>
            <NavLink to="/about" className={linkClass}>About</NavLink>
            <NavLink to="/services" className={linkClass}>Services</NavLink>
            <NavLink to="/gallery" className={linkClass}>Gallery</NavLink>
            <NavLink to="/contact" className={linkClass}>Contact</NavLink>
            {customer ? (
              <>
                <NavLink to="/my-bookings" className={linkClass}>My Bookings</NavLink>
                <button onClick={logout} className="px-3 py-2 text-sm text-[var(--color-text-light)] hover:text-[var(--color-accent)]">Logout</button>
              </>
            ) : (
              <NavLink to="/login" className={linkClass}>Login</NavLink>
            )}
            <Link to="/book" className="ml-3 px-5 py-2 bg-[var(--color-accent)] text-white rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity">
              Book Now
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button onClick={() => setOpen(!open)} className="md:hidden text-[var(--color-text)]">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={open ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden pb-4 space-y-1">
            <NavLink to="/" end className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>Home</NavLink>
            <NavLink to="/about" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>About</NavLink>
            <NavLink to="/services" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>Services</NavLink>
            <NavLink to="/gallery" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>Gallery</NavLink>
            <NavLink to="/contact" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>Contact</NavLink>
            {customer ? (
              <>
                <NavLink to="/my-bookings" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>My Bookings</NavLink>
                <button onClick={() => { logout(); setOpen(false); }} className="block px-3 py-2 text-sm text-left w-full">Logout</button>
              </>
            ) : (
              <NavLink to="/login" className="block px-3 py-2 text-sm" onClick={() => setOpen(false)}>Login</NavLink>
            )}
            <Link to="/book" className="block mx-3 mt-2 px-5 py-2 bg-[var(--color-accent)] text-white rounded-lg text-sm font-semibold text-center" onClick={() => setOpen(false)}>
              Book Now
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
